import {Component, OnInit, ViewChild} from '@angular/core';
import {DataTableDirective} from "angular-datatables";
import {BrandService} from "../../services/brand.service";
import {first} from "rxjs/operators";

declare var swal: any;

@Component({
  selector: 'app-brands',
  templateUrl: './brands.component.html',
  styleUrls: ['./brands.component.scss']
})
export class BrandsComponent implements OnInit {

    dtOptions: DataTables.Settings = {};
    brands: any[];
    @ViewChild(DataTableDirective) private dtElement;

    constructor(
        private brandService: BrandService,
    ) { }

    ngOnInit(): void {
        this.dtOptions = {
            pagingType: 'full_numbers',
            pageLength: 10,
            serverSide: true,
            processing: true,
            ajax: (dataTablesParameters: any, callback) => {
                this.brandService.getDatatable(dataTablesParameters)
                    .pipe(first())
                    .subscribe(response => {
                        this.brands = response.data;
                        callback({
                            recordsTotal: response.recordsTotal,
                            recordsFiltered: response.recordsFiltered,
                            data: []
                        });
                    });
            },
            columns: [
                {data: 'name'},
                {data: 'photo', searchable: false, orderable: false},
            ]
        };
    }

    private async reloadTable() {
        let dtIntance = await this.dtElement.dtInstance;
        dtIntance.ajax.reload();
    }

    delete(item: any): void {
        swal.fire({
            title: '¿Estás seguro que deseas eliminar este registro?',
            showCancelButton: true,
            confirmButtonText: 'Si, elimínalo!',
            showLoaderOnConfirm: true,
            preConfirm: (arg) => {
                return this.brandService.delete(item.id)
                    .pipe(first())
                    .subscribe(response => {
                        swal.fire({
                            title: 'Elemento eliminado con éxito',
                            type: 'success'
                        });
                        this.reloadTable();
                    }, error => {
                        swal.fire({
                            title: error,
                            type: 'error'
                        });
                        return error;
                    });
            },
            allowOutsideClick: () => !swal.isLoading()
        }).then((result) => {
        });
    }
}
